import React, { Component, Fragment } from "react";
import { Container, Col, Row, Card } from "react-bootstrap";
import classes from "./Categories.module.css";

class Categories extends Component {
  render() {
    return (
      <Fragment>
        <Container>
          <span className="section-header">Categories</span>
          <Row className="m-0">
            <Col className="p-0" xl={6} lg={6} md={12} sm={12} xs={12}>
              <Row className="p-3">
                <Col className="p-0" key={1} xl={3} lg={3} md={3} sm={6} xs={6}>
                  <Card
                    className={`${classes["card-categories"]} py-3 border border-top-0 border-start-0`}
                  >
                    <Container>
                      <Card.Img
                        variant="top"
                        src="https://lzd-img-global.slatic.net/g/p/78a433741f99615fb2013dad995c29ff.jpg_80x80q80.jpg_.webp"
                        alt="category-1"
                        width="80px"
                        height="80px"
                      />
                    </Container>
                    <Card.Body className="text-center px-0 pt-2 pb-0">
                      <span className="card-product-title">
                        Home Office Chairs
                      </span>
                    </Card.Body>
                  </Card>
                </Col>
                <Col className="p-0" key={2} xl={3} lg={3} md={3} sm={6} xs={6}>
                  <Card
                    className={`${classes["card-categories"]} py-3 border border-top-0 border-start-0`}
                  >
                    <Container>
                      <Card.Img
                        variant="top"
                        src="https://lzd-img-global.slatic.net/g/p/78a433741f99615fb2013dad995c29ff.jpg_80x80q80.jpg_.webp"
                        alt="category-1"
                        width="80px"
                        height="80px"
                      />
                    </Container>
                    <Card.Body className="text-center px-0 pt-2 pb-0">
                      <span className="card-product-title">
                        Home Office Chairs
                      </span>
                    </Card.Body>
                  </Card>
                </Col>
                <Col className="p-0" key={3} xl={3} lg={3} md={3} sm={6} xs={6}>
                  <Card
                    className={`${classes["card-categories"]} py-3 border border-top-0 border-start-0`}
                  >
                    <Container>
                      <Card.Img
                        variant="top"
                        src="https://lzd-img-global.slatic.net/g/p/78a433741f99615fb2013dad995c29ff.jpg_80x80q80.jpg_.webp"
                        alt="category-1"
                        width="80px"
                        height="80px"
                      />
                    </Container>
                    <Card.Body className="text-center px-0 pt-2 pb-0">
                      <span className="card-product-title">
                        Home Office Chairs
                      </span>
                    </Card.Body>
                  </Card>
                </Col>
                <Col className="p-0" key={4} xl={3} lg={3} md={3} sm={6} xs={6}>
                  <Card
                    className={`${classes["card-categories"]} py-3 border border-top-0 border-start-0`}
                  >
                    <Container>
                      <Card.Img
                        variant="top"
                        src="https://lzd-img-global.slatic.net/g/p/78a433741f99615fb2013dad995c29ff.jpg_80x80q80.jpg_.webp"
                        alt="category-1"
                        width="80px"
                        height="80px"
                      />
                    </Container>
                    <Card.Body className="text-center px-0 pt-2 pb-0">
                      <span className="card-product-title">
                        Home Office Chairs
                      </span>
                    </Card.Body>
                  </Card>
                </Col>
                <Col className="p-0" key={5} xl={3} lg={3} md={3} sm={6} xs={6}>
                  <Card
                    className={`${classes["card-categories"]} py-3 border border-top-0 border-start-0 border-bottom-0`}
                  >
                    <Container>
                      <Card.Img
                        variant="top"
                        src="https://lzd-img-global.slatic.net/g/p/78a433741f99615fb2013dad995c29ff.jpg_80x80q80.jpg_.webp"
                        alt="category-1"
                        width="80px"
                        height="80px"
                      />
                    </Container>
                    <Card.Body className="text-center px-0 pt-2 pb-0">
                      <span className="card-product-title">
                        Home Office Chairs
                      </span>
                    </Card.Body>
                  </Card>
                </Col>
                <Col className="p-0" key={6} xl={3} lg={3} md={3} sm={6} xs={6}>
                  <Card
                    className={`${classes["card-categories"]} py-3 border border-top-0 border-start-0 border-bottom-0`}
                  >
                    <Container>
                      <Card.Img
                        variant="top"
                        src="https://lzd-img-global.slatic.net/g/p/78a433741f99615fb2013dad995c29ff.jpg_80x80q80.jpg_.webp"
                        alt="category-1"
                        width="80px"
                        height="80px"
                      />
                    </Container>
                    <Card.Body className="text-center px-0 pt-2 pb-0">
                      <span className="card-product-title">
                        Home Office Chairs
                      </span>
                    </Card.Body>
                  </Card>
                </Col>
                <Col className="p-0" key={7} xl={3} lg={3} md={3} sm={6} xs={6}>
                  <Card
                    className={`${classes["card-categories"]} py-3 border border-top-0 border-start-0 border-bottom-0`}
                  >
                    <Container>
                      <Card.Img
                        variant="top"
                        src="https://lzd-img-global.slatic.net/g/p/78a433741f99615fb2013dad995c29ff.jpg_80x80q80.jpg_.webp"
                        alt="category-1"
                        width="80px"
                        height="80px"
                      />
                    </Container>
                    <Card.Body className="text-center px-0 pt-2 pb-0">
                      <span className="card-product-title">
                        Home Office Chairs
                      </span>
                    </Card.Body>
                  </Card>
                </Col>
                <Col className="p-0" key={8} xl={3} lg={3} md={3} sm={6} xs={6}>
                  <Card
                    className={`${classes["card-categories"]} py-3 border border-top-0 border-start-0 border-bottom-0`}
                  >
                    <Container>
                      <Card.Img
                        variant="top"
                        src="https://lzd-img-global.slatic.net/g/p/78a433741f99615fb2013dad995c29ff.jpg_80x80q80.jpg_.webp"
                        alt="category-1"
                        width="80px"
                        height="80px"
                      />
                    </Container>
                    <Card.Body className="text-center px-0 pt-2 pb-0">
                      <span className="card-product-title">
                        Home Office Chairs
                      </span>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Col>

            <Col className="p-0" xl={6} lg={6} md={12} sm={12} xs={12}>
              <Row className="p-3">
                <Col className="p-0" key={9} xl={3} lg={3} md={3} sm={6} xs={6}>
                  <Card
                    className={`${classes["card-categories"]} py-3 border border-top-0 border-start-0`}
                  >
                    <Container>
                      <Card.Img
                        variant="top"
                        src="https://lzd-img-global.slatic.net/g/p/78a433741f99615fb2013dad995c29ff.jpg_80x80q80.jpg_.webp"
                        alt="category-1"
                        width="80px"
                        height="80px"
                      />
                    </Container>
                    <Card.Body className="text-center px-0 pt-2 pb-0">
                      <span className="card-product-title">
                        Home Office Chairs
                      </span>
                    </Card.Body>
                  </Card>
                </Col>
                <Col
                  className="p-0"
                  key={10}
                  xl={3}
                  lg={3}
                  md={3}
                  sm={6}
                  xs={6}
                >
                  <Card
                    className={`${classes["card-categories"]} py-3 border border-top-0 border-start-0`}
                  >
                    <Container>
                      <Card.Img
                        variant="top"
                        src="https://lzd-img-global.slatic.net/g/p/78a433741f99615fb2013dad995c29ff.jpg_80x80q80.jpg_.webp"
                        alt="category-1"
                        width="80px"
                        height="80px"
                      />
                    </Container>
                    <Card.Body className="text-center px-0 pt-2 pb-0">
                      <span className="card-product-title">
                        Home Office Chairs
                      </span>
                    </Card.Body>
                  </Card>
                </Col>
                <Col
                  className="p-0"
                  key={11}
                  xl={3}
                  lg={3}
                  md={3}
                  sm={6}
                  xs={6}
                >
                  <Card
                    className={`${classes["card-categories"]} py-3 border border-top-0 border-start-0`}
                  >
                    <Container>
                      <Card.Img
                        variant="top"
                        src="https://lzd-img-global.slatic.net/g/p/78a433741f99615fb2013dad995c29ff.jpg_80x80q80.jpg_.webp"
                        alt="category-1"
                        width="80px"
                        height="80px"
                      />
                    </Container>
                    <Card.Body className="text-center px-0 pt-2 pb-0">
                      <span className="card-product-title">
                        Home Office Chairs
                      </span>
                    </Card.Body>
                  </Card>
                </Col>
                <Col
                  className="p-0"
                  key={12}
                  xl={3}
                  lg={3}
                  md={3}
                  sm={6}
                  xs={6}
                >
                  <Card
                    className={`${classes["card-categories"]} py-3 border border-top-0 border-start-0 border-end-0`}
                  >
                    <Container>
                      <Card.Img
                        variant="top"
                        src="https://lzd-img-global.slatic.net/g/p/78a433741f99615fb2013dad995c29ff.jpg_80x80q80.jpg_.webp"
                        alt="category-1"
                        width="80px"
                        height="80px"
                      />
                    </Container>
                    <Card.Body className="text-center px-0 pt-2 pb-0">
                      <span className="card-product-title">
                        Home Office Chairs
                      </span>
                    </Card.Body>
                  </Card>
                </Col>
                <Col
                  className="p-0"
                  key={13}
                  xl={3}
                  lg={3}
                  md={3}
                  sm={6}
                  xs={6}
                >
                  <Card
                    className={`${classes["card-categories"]} py-3 border border-top-0 border-start-0 border-bottom-0`}
                  >
                    <Container>
                      <Card.Img
                        variant="top"
                        src="https://lzd-img-global.slatic.net/g/p/78a433741f99615fb2013dad995c29ff.jpg_80x80q80.jpg_.webp"
                        alt="category-1"
                        width="80px"
                        height="80px"
                      />
                    </Container>
                    <Card.Body className="text-center px-0 pt-2 pb-0">
                      <span className="card-product-title">
                        Home Office Chairs
                      </span>
                    </Card.Body>
                  </Card>
                </Col>
                <Col
                  className="p-0"
                  key={14}
                  xl={3}
                  lg={3}
                  md={3}
                  sm={6}
                  xs={6}
                >
                  <Card
                    className={`${classes["card-categories"]} py-3 border border-top-0 border-start-0 border-bottom-0`}
                  >
                    <Container>
                      <Card.Img
                        variant="top"
                        src="https://lzd-img-global.slatic.net/g/p/78a433741f99615fb2013dad995c29ff.jpg_80x80q80.jpg_.webp"
                        alt="category-1"
                        width="80px"
                        height="80px"
                      />
                    </Container>
                    <Card.Body className="text-center px-0 pt-2 pb-0">
                      <span className="card-product-title">
                        Home Office Chairs
                      </span>
                    </Card.Body>
                  </Card>
                </Col>
                <Col
                  className="p-0"
                  key={15}
                  xl={3}
                  lg={3}
                  md={3}
                  sm={6}
                  xs={6}
                >
                  <Card
                    className={`${classes["card-categories"]} py-3 border border-top-0 border-start-0 border-bottom-0`}
                  >
                    <Container>
                      <Card.Img
                        variant="top"
                        src="https://lzd-img-global.slatic.net/g/p/78a433741f99615fb2013dad995c29ff.jpg_80x80q80.jpg_.webp"
                        alt="category-1"
                        width="80px"
                        height="80px"
                      />
                    </Container>
                    <Card.Body className="text-center px-0 pt-2 pb-0">
                      <span className="card-product-title">
                        Home Office Chairs
                      </span>
                    </Card.Body>
                  </Card>
                </Col>
                <Col
                  className="p-0"
                  key={16}
                  xl={3}
                  lg={3}
                  md={3}
                  sm={6}
                  xs={6}
                >
                  <Card
                    className={`${classes["card-categories"]} py-3 border border-top-0 border-start-0 border-bottom-0 border-end-0`}
                  >
                    <Container>
                      <Card.Img
                        variant="top"
                        src="https://lzd-img-global.slatic.net/g/p/78a433741f99615fb2013dad995c29ff.jpg_80x80q80.jpg_.webp"
                        alt="category-1"
                        width="80px"
                        height="80px"
                      />
                    </Container>
                    <Card.Body className="text-center px-0 pt-2 pb-0">
                      <span className="card-product-title">
                        Home Office Chairs
                      </span>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
        <br />
      </Fragment>
    );
  }
}

export default Categories;
